import { render, staticRenderFns } from "./OpenMyPurchaseRequest.vue?vue&type=template&id=4713f674&scoped=true&"
import script from "./OpenMyPurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./OpenMyPurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./OpenMyPurchaseRequest.vue?vue&type=style&index=0&id=4713f674&prod&lang=scss&scoped=true&"
import style1 from "./OpenMyPurchaseRequest.vue?vue&type=style&index=1&id=4713f674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713f674",
  null
  
)

export default component.exports